import { AbstractControl, FormControl } from '@angular/forms';
import { TitleId } from '@domgen/dgx-fe-common';
import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { CLPApplianceDetailsPersonDetailsFormField } from './clp-appliance-details-person-form-field.enum';

export interface CLPApplianceDetailsPersonDetailsForm {
  [CLPApplianceDetailsPersonDetailsFormField.Address]: AbstractControl<FormOverrideAddress>;
  [CLPApplianceDetailsPersonDetailsFormField.FirstName]: FormControl<
    string | null
  >;
  [CLPApplianceDetailsPersonDetailsFormField.Surname]: FormControl<
    string | null
  >;
  [CLPApplianceDetailsPersonDetailsFormField.Title]: FormControl<TitleId | null>;
}
